<template>
  <section>
    <template v-if="!hasBesoins">
      <generer-besoins
        :commande="commande"
        @refresh="refresh" />
    </template>
    <template v-else>
      <commande-card
        :commande="commande"
        class="mgb-20px" />
      <recapitulatif-card
        :commande="commande"
        :besoins="besoinsItems"
        class="mgb-20px" />
      <affiches-card
        :nameStore="nameStore"
        :commande="commande"
        :besoins="besoinsItems"
        @refresh="hasBesoins = besoinsItems.length > 0" />
    </template>
  </section>
</template>

<script>
import GenererBesoins from '@/components/commande/logistiqueImpression/stepImpression/genererBesoins';
import CommandeCard from '@/components/commande/logistiqueImpression/stepImpression/commandeCard';
import RecapitulatifCard from '@/components/commande/logistiqueImpression/stepImpression/recapitulatifCard';
import AffichesCard from '@/components/commande/logistiqueImpression/stepImpression/affichesCard';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { TYPE_IMPRESSION } from '@/configuration/bodac/besoin/besoinConfig';
import messageErreur from '@/services/general/messageErreur';

export default {
  name: 'StepImpressionProvider',
  props: {
    commande: {
      type: Object,
      required: true,
    },
    nameStore: {
      type: String,
      required: true,
    },
  },
  components: {
    GenererBesoins,
    CommandeCard,
    RecapitulatifCard,
    AffichesCard,
  },
  data() {
    return {
      hasBesoins: false,
      loadingComponent: null,
    };
  },
  computed: {
    besoinsItems() {
      return this.$store.getters[`${this.nameStore}/items`];
    },
  },
  methods: {
    actionGetAllBesoins(payload) {
      return this.$store.dispatch(`${this.nameStore}/load`, payload);
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    async refresh() {
      const payload = {
        limit: NO_PAGINATION,
        query: { commandeId: this.commande.id, typeBesoin: TYPE_IMPRESSION },
        sorting: 'creationTime DESC',
      };
      this.debutLoading();
      try {
        await this.actionGetAllBesoins(payload);
        this.hasBesoins = this.besoinsItems.length > 0;
      } catch (error) {
        messageErreur(this.$i18n);
        throw error;
      } finally {
        this.finLoading();
      }
    },
  },
  async mounted() {
    await this.refresh();
  },
};

</script>
